import { useState } from 'react';
import { useDrawer } from '../../../shared/drawer';
import { PageBody } from '../../../elements/page-body';
import { Table } from '../../../elements/table';
import { EstadoMultasForm } from './estados-multa-form';


export const EstadosMultas = () => {
    const { open, close } = useDrawer();
    const [refresh, setRefresh] = useState<string | null>(null);




    const handleNewAction = () => {
        open('common.label.new-estado-multa', <EstadoMultasForm close={handleClose} />);
    };

    const handleClose = () => {
        setRefresh(Date.now().toString());
        close();
    };


    return (
        <PageBody
            newAction={handleNewAction}
            title={'common.label.estados-multa'}
            newActionTitle={'common.label.new-estado-multa'}
        >
            <>
                <Table
                    path="/fleet/sanction-states/"
                    deletePath="/fleet/sanction-states/"
                    callBeforeDrawerClosed={handleClose}
                    Form={EstadoMultasForm}
                    withPagination
                    refresh={refresh}
                    headers={[
                        {
                            key: 'name',
                            label: 'common.form-label.name'
                        },
                        {
                            key: 'description',
                            label: 'common.form-label.descripcion'
                        },
                        {
                            key: 'state',
                            type:'boolean',
                            label: 'common.label.gestionado'
                        }
                    ]}
                />
            </>
        </PageBody>
    );
};